import _typeof from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/helpers/typeof';


export var state = function state() {
  return {
    moduleSessionCollection: {},
    userCollection: {},
    userEdited: null
  };
};

export var mutations = {
  setMarkAttendanceCollection: function setMarkAttendanceCollection(state, _ref) {
    var pMattCollection = _ref.pMattCollection,
        msCollection = _ref.msCollection;

    console.log('\n\n ======= Vuex - report ====== \n', typeof pMattCollection === 'undefined' ? 'undefined' : _typeof(pMattCollection), '\n --------------');

    state.userCollection = pMattCollection;

    state.moduleSessionCollection = msCollection;
  },
  setUserEdited: function setUserEdited(state, userActor) {
    state.userEdited = userActor;
  }
};


//////////////////
// WEBPACK FOOTER
// ./store/report.js
// module id = ./store/report.js
// module chunks = 20